import React from 'react';
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
const COLORS = ['#1890FF', '#17C4E0', '#65DD33', '#EFCC20', '#FF4D4D', '#B344D5' ];

const CustomPieChart = (props) => {
    const { data, colorFill, width, height} = props;  
    console.log(data);
    return (
        <PieChart width={width} height={height}>
            <Pie
                dataKey="value"
                isAnimationActive={true}
                data={data}
                cx={width / 2}
                cy={height / 2}
                outerRadius={80}
                fill={colorFill}
                label
            >
            { data.map((entry, index) => (                
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
            </Pie>
            <Tooltip />
        </PieChart>
  );
};


export default CustomPieChart;
